/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CardMessagingActivityUndelivered_EmbedQuery = {
    readonly undeliveredCount: number | null;
    readonly " $refType": "CardMessagingActivityUndelivered_EmbedQuery";
};
export type CardMessagingActivityUndelivered_EmbedQuery$data = CardMessagingActivityUndelivered_EmbedQuery;
export type CardMessagingActivityUndelivered_EmbedQuery$key = {
    readonly " $data"?: CardMessagingActivityUndelivered_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CardMessagingActivityUndelivered_EmbedQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdAtFrom"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdAtTo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CardMessagingActivityUndelivered_EmbedQuery",
  "selections": [
    {
      "alias": "undeliveredCount",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "gte",
                      "variableName": "createdAtFrom"
                    },
                    {
                      "kind": "Variable",
                      "name": "lte",
                      "variableName": "createdAtTo"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "createdAt"
                }
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            },
            {
              "kind": "Literal",
              "name": "status",
              "value": "undelivered"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "kind": "ScalarField",
      "name": "messageCount",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '9d01ddee302b7f44d27f78c42fd761cb';
export default node;
